import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent } from "vue"

import { computed, ref } from "vue";
import { VersionSchema } from "@/types";
import { versionToString } from "@/util";
import { getVersionApiStore, permissionStore, projectStore } from "@/hooks";
import { TextButton, ListItem, IconButton, FlexBox } from "@/components/common";
import { CreateVersionModal } from "@/components/project/creator";


/**
 * Displays the current project version, and allows it to be changed.
 */
const __default__ = {
  name: "VersionSelector",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const openCreateVersion = ref(false);

const allVersions = computed(() => projectStore.allVersions);
const project = computed(() => projectStore.project);
const isProjectDefined = computed(() => projectStore.isProjectDefined);

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_versions")
);
const deletable = computed(
  () => displayActions.value && allVersions.value.length > 1
);

/**
 * Adds the new version the version list and loads that version.
 * @param version - The new version.
 */
async function handleVersionCreated(version: VersionSchema): Promise<void> {
  openCreateVersion.value = false;
  await getVersionApiStore.handleLoad(version.versionId);
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!

  return (isProjectDefined.value)
    ? (_openBlock(), _createBlock(_component_q_select, {
        key: 0,
        modelValue: _unref(getVersionApiStore).currentVersion,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(getVersionApiStore).currentVersion) = $event)),
        standout: "",
        "bg-color": "transparent",
        class: "nav-breadcrumb",
        "options-selected-class": "primary",
        label: "Version",
        options: allVersions.value,
        "option-value": "versionId",
        onPopupShow: _cache[3] || (_cache[3] = ($event: any) => (_unref(getVersionApiStore).handleLoadVersions()))
      }, {
        selected: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(versionToString)(_unref(getVersionApiStore).currentVersion)), 1)
        ]),
        option: _withCtx(({ opt, itemProps }) => [
          _createVNode(_unref(ListItem), _mergeProps(itemProps, {
            title: _unref(versionToString)(opt),
            "action-cols": 2
          }), {
            actions: _withCtx(() => [
              _createVNode(_unref(FlexBox), { justify: "end" }, {
                default: _withCtx(() => [
                  (deletable.value)
                    ? (_openBlock(), _createBlock(_unref(IconButton), {
                        key: 0,
                        small: "",
                        tooltip: `Delete ${_unref(versionToString)(opt)}`,
                        icon: "delete",
                        "data-cy": "button-version-delete",
                        onClick: ($event: any) => (_unref(getVersionApiStore).handleDelete(opt))
                      }, null, 8, ["tooltip", "onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1040, ["title"])
        ]),
        "after-options": _withCtx(() => [
          (displayActions.value)
            ? (_openBlock(), _createBlock(_unref(TextButton), {
                key: 0,
                text: "",
                label: "Add Version",
                icon: "add",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (openCreateVersion.value = true))
              }))
            : _createCommentVNode("", true)
        ]),
        after: _withCtx(() => [
          _createVNode(_unref(CreateVersionModal), {
            open: openCreateVersion.value,
            project: project.value,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (openCreateVersion.value = false)),
            onCreate: handleVersionCreated
          }, null, 8, ["open", "project"])
        ]),
        _: 1
      }, 8, ["modelValue", "options"]))
    : _createCommentVNode("", true)
}
}

})